import { ordinalize } from "@/utilities/ordinalize";

export default {
  name: "workOrderLots",
  data() {
    return {};
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    isFieldWorker: function() {
      return this.$store.getters.isFieldWorker;
    },
  },
  methods: {
    ordinalize: function(i) {
      return ordinalize(i);
    },
  },
};
